export default "__VITE_ASSET__CS7diyeu__"